import {
    SET_PART_PAYMENT_LOADER,
    SET_PART_PAYMENT_LIST
} from '../actionTypes/partPaymentActionType';

const initialState: any = {
    isLoading: false,
    partPaymentData: {},
}

const partPaymentReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_PART_PAYMENT_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }
        case SET_PART_PAYMENT_LIST:
            return {
                ...state,
                partPaymentData: action.payload
            }
        default:
            return state;
    }
}

export default partPaymentReducer
